import React, { FC, ReactElement } from 'react'
import { Flex } from 'rebass'
import { Button, Label } from '../NeutronComponents/atoms/button/Button'
import { useDispatch } from 'react-redux'
import { displayModal } from '../../../store/actions/ui'

type DeleteBannerProps = {
  isCloseBanner?: boolean
}

export const DeleteBanner: FC<DeleteBannerProps> = ({
  isCloseBanner = false,
}): ReactElement => {
  const dispatch = useDispatch()

  const title = isCloseBanner
    ? 'Are you sure you want to close this banner?'
    : 'Are you sure you want to delete this banner?'

  const subtitle = isCloseBanner
    ? 'This banner will be retired.'
    : 'This banner will be permanently deleted.'

  const confirmLabel = isCloseBanner ? 'Close' : 'Delete'
  const confirmType = isCloseBanner ? 'closeBanner' : 'deleteBanner'
  const confirmAction = isCloseBanner ? 'remove' : 'delete'

  return (
    <Flex
      sx={{
        borderRadius: 5,
        boxShadow: '0 2px 7px 4px rgba(0,0,0,0.13)',
        padding: '15px 30px',
        width: 500,
        background: '#fff',
      }}
      flexDirection="column"
      alignItems="center"
    >
      <p style={{ fontSize: 20, fontWeight: 'bold', textAlign: 'center' }}>
        {title}
      </p>
      <p style={{ textAlign: 'center' }}>{subtitle}</p>
      <Flex justifyContent={'center'} alignItems={'center'}>
        <Button
          type={'flat'}
          color={'danger'}
          onClick={() =>
            dispatch(
              displayModal({
                show: false,
                type: undefined,
                confirmation: 'cancel',
              })
            )
          }
          size={'large'}
        >
          <Label value="Cancel" />
        </Button>
        <Button
          type={'flat'}
          color={'success'}
          onClick={() =>
            dispatch(
              displayModal({
                show: false,
                type: confirmType,
                confirmation: confirmAction,
              })
            )
          }
          size={'large'}
        >
          <Label value={confirmLabel} />
        </Button>
      </Flex>
    </Flex>
  )
}
